module.exports = __webpack_public_path__ + "img/instagram.1f5d4bc1.png";